import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@env';
import { catchError } from 'rxjs';
import { ErrorHandlerService } from './response-utils.service';
import { OrgUsersPasswordDeleteDTO } from '@components/customer';

@Injectable({ providedIn: 'root' })
export class UserManagementService {
  private readonly URL: string = environment.apiUrl + '/management';

  private readonly KEYCLOAK_URL: string = environment.idProvider + '/custom';

  private readonly REQUEST_TIMEOUT: string = environment.requestTimeout;

  private http = inject(HttpClient);
  private errorHandler = inject(ErrorHandlerService);

  getAccountManager(kcguid: string) {
    const url = `${this.URL}/account-manager/${kcguid}`;
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getManagerList() {
    const url = this.URL + '/account-manager/list';
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  // Needs to be able to handle requests up to 60 seconds
  createManager(jsonData: string) {
    return this.http
      .post(this.URL + '/account-manager', jsonData, {
        headers: { timeout: this.REQUEST_TIMEOUT },
      })
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  // Needs to be able to handle requests up to 60 seconds
  editmanager(jsonData: string) {
    return this.http
      .put(this.URL + '/account-manager', jsonData, {
        headers: { timeout: this.REQUEST_TIMEOUT },
      })
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  checkEmail(email: string) {
    const url = this.URL + '/user/verifyEmail/' + email;
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getFleetManagersForCustomer(customerKey: string) {
    const url = `${this.KEYCLOAK_URL}/groups/${customerKey}/fleet-managers`;
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  deletePasswords(customerKey: string, orgUsersPasswordDeleteDTO: OrgUsersPasswordDeleteDTO) {
    const url = this.URL + '/organisations/delete-passwords/' + customerKey;
    return this.http
      .delete(url, { body: orgUsersPasswordDeleteDTO })
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }
}
